<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     设备头像
  +---------------------------------------------------------------------------------------
-->
<template>
  <el-image
    class="f-equip-avatar image rounded"
    :class="{ [size]: size }"
    :src="equip.avatar || (defaultShowGo ? equip.go_image : '')"
    :preview-src-list="preview ? [equip.avatar || (defaultShowGo ? equip.go_image : '')] : []"
    @error="handleError"
  >
    <div slot="error">
      <img
        class="image rounded"
        :class="{ [size]: size }"
        src="@/assets/default-equip-avatar.png"
      />
    </div>
  </el-image>
</template>

<script>
export default {
  name: "FEquipAvatar",

  props: {
    equip: {
      type: Object,
      default() {
        return {};
      },
    },

    defaultShowGo: {
      type: Boolean,
      default: true,
    },

    size: {
      type: String,
      default: '',
    },

    preview: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      // previewList: []
    }
  },

  methods: {
    handleError() {
      // this.previewList = []
    }
  },
}
</script>

